<template>
  <!-- TODO: 305 -->
  <div class="modal" v-if="visible">
    <div class="modal-content" v-if="product" v-click-outside="close">
      <div class="address-modal">
        <div class="cart-added container">
          <div class="cart-added__header">カートに追加されました。</div>
          <div class="cart-added__body">
            <div class="cart-added__item">
              <div class="cart-added__item__image">
                <img v-lazy="product.image_file" />
              </div>
              <div class="cart-added__item__info">
                <div class="cart-added__item__name">{{ product.name }}</div>
                <div class="cart-added__item__price">
                  {{ totalPrice | priceFilter }}
                  <span class="cart-added__item__price__suffix">税込</span>
                </div>
                <div class="cart-added__item__detail">
                  色:
                  <b>{{ product.color_i18n }}</b>
                </div>
                <div class="cart-added__item__detail">
                  商品数:
                  <b>{{ quantity }}</b>
                </div>
              </div>
            </div>
            <div class="cart-added__summary" v-if="order">
              <p class="cart-added__summary__count">
                商品は{{ order.order_items.length }}点あります。
              </p>
              <p class="cart-added__summary__total">
                商品小計:
                <span class="cart-added__summary__total__value">{{
                  order.goods_price | priceFilter
                }}</span>
              </p>
              <p class="cart-added__summary__total">
                割引金額:
                <span class="cart-added__summary__total__value">{{
                  (Math.abs(order.discount_price) * -1) | priceFilter
                }}</span>
              </p>
              <p class="cart-added__summary__total">
                送料:
                <span class="cart-added__summary__total__value">{{
                  order.shipping_fee | priceFilter
                }}</span>
              </p>
              <p class="cart-added__summary__total">
                  消費税:
                  <span
                    class="cart-added__summary__total__value"
                  >{{ order.tax | priceFilter }}</span>
              </p>
              <p class="cart-added__summary__total">
                合計:
                <span class="cart-added__summary__total__value">{{
                  order.total_price | priceFilter
                }}</span
                >(税込)
              </p>
              <div class="cart-added__summary__buttons">
                <button @click="moveToCart" class="button invert">
                  レジに進む
                </button>
                <button @click="close" class="button invert">
                  ショッピング続く
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data: function () {
    return {
      visible: false,
      product: null,
      quantity: null,
      order: null,
    };
  },
  methods: {
    open: function (data) {
      this.visible = true;

      this.product = data.product;
      this.quantity = data.quantity;
      this.order = data.order;
    },
    close: function () {
      this.visible = false;
    },
    moveToCart: function () {
      window.location.replace("/checkout");
    },
  },
  computed: {
    totalPrice: function () {
      return this.quantity * this.product.new_price_with_tax;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-content {
  max-width: 1230px;
  background: white;
}
</style>
